module.exports = __webpack_public_path__ + "media/images/core_values/spirit_of_adventure-b47dcdd1c5e1e05712e37a01965174c9.png";